export default __webpack_public_path__ + "static/media/anpan.13623573.png";